/* Throttle function */
function essThrottle(fn,time){
  var timer = null;
  return function(){
    if(!timer) {
      timer = setTimeout(function(){
        fn();
        timer = null;
      },time);
    }
  };
} 

function essRestartEntranceAnimation(){
  document.body.classList.remove('ess-nav-overflow-hidden');
  document.body.classList.remove('menu-active');
  void document.body.offsetWidth;
  setTimeout(function(){
    document.body.classList.add('ess-loading-animation-in');
  },400);
  setTimeout(function(){
    document.body.classList.remove('ess-preload');
  },1000);
}
/* Back/forward navigation */
window.addEventListener('popstate',function(){
  essRestartEntranceAnimation();
});
/* Page restored from browser cache */
window.addEventListener('pageshow',function(){
  essRestartEntranceAnimation();
});
document.addEventListener('visibilitychange',function(){
  if(!document.hidden){
    essRestartEntranceAnimation();
  }
});

document.addEventListener('DOMContentLoaded',function(){

  /* Loading animation entering a page */
  setTimeout(function(){
    document.body.classList.add('ess-loading-animation-in');
  },400);
  setTimeout(function(){
    document.body.classList.remove('ess-preload');
  },1000);

  /* Loading animation leaving a page */
  document.addEventListener('click',function(essLinkClick){
    const essLink = essLinkClick.target.closest('a');
    if(!essLink || !essLink.href) return;
    if(essLink.id === 'cart-icon-bubble') return;
    if(essLink.target === '_blank') return;
    if(essLink.hasAttribute('download')) return;
    if(essLink.classList.contains('visually-hidden')) return;
    const essSkippedProtocols = ['mailto:','tel:','sms:','javascript:','file:','ftp:'];
    const essHasSkippedProtocol = essSkippedProtocols.some(protocol => 
      essLink.href.toLowerCase().startsWith(protocol));
    if(essHasSkippedProtocol) return;
    const essDownloadExtensions = /\.(pdf|zip|tar|jpg|jpeg|png|webp|svg|gz|rar|exe|dmg|csv|xlsx|docx|mp3|mp4)$/i;
    if(essDownloadExtensions.test(essLink.pathname)) return;
    try{
      const essLinkUrl = new URL(essLink.href);
      const essCurrentUrl = new URL(window.location.href);
      if(essLinkUrl.hostname === essCurrentUrl.hostname){
        essLinkClick.preventDefault();
        document.body.classList.remove('ess-loading-animation-in');
        document.body.classList.add('ess-preload');
        setTimeout(function(){
          window.location.href = essLinkUrl;
        },600);
      }
    } catch(error){
      console.error('Ungültige URL gefunden:',error);
    }
  });

  /* Listen for resizing */
  window.addEventListener('resize',essThrottle(essResizing,50));
  
  /* Variables */
  const essButtons = document.querySelectorAll('.ess-header .ess-button');
  const essNavButton = document.getElementById('ess-navigation');
  const essHeader = document.querySelector('.section-header');
  const essMenu = document.getElementById('ess-menu-overlay');
  const essWishlistCloseButton = document.getElementById('ess-wishlist-close-button');
  const essWishlistOpenButton = document.getElementById('ess-wishlist-button');
  const essWishlist = document.getElementById('ess-wishlist');
  const essWishlistOverlay = document.getElementById('ess-wishlist-overlay');


  let navButtonDisabled = false;
  let essMenuActive = false;
  let wishlistButtonDisabled = false;
  let essWishlistActive = false;

  /* On resize */
  function essResizing(){
    document.documentElement.style.setProperty('--viewport-height',`${window.innerHeight}px`);
    document.documentElement.style.setProperty('--header-height',`${essHeader.offsetHeight}px`);
    document.documentElement.style.setProperty('--header-bottom-position',`${parseInt(essHeader.getBoundingClientRect().bottom)}px`);
  }
  // Run it once on load
  essResizing();

  /* Focus trap navigation */
  function trapNav(eventNav){
    // Get all links
    const navFocusable = essMenu.querySelectorAll('summary,button,a,input,select,textarea,[tabindex="0"]');
    const allElements = [essNavButton,...navFocusable];
    const navFirst = allElements[0];
    const navSecond = allElements[1];
    const navLast = allElements[allElements.length - 1];
    // Handle Escape key
    if(eventNav.key === 'Escape'){
      document.body.classList.toggle('menu-active');
      document.body.classList.remove('ess-nav-overflow-hidden');
      essMenuActive = false;
      navButtonDisabled = false;
      window.removeEventListener('keydown',trapNav);
      navFirst.focus(); // Return focus to the toggle button
      eventNav.preventDefault();
      return;
    }
    // Handle Tab key (Focus Trap)
    if (eventNav.key === 'Tab'){
      if(eventNav.shiftKey){ // Shift + Tab (Backward)
        if(document.activeElement === navFirst){
          navLast.focus();
          eventNav.preventDefault();
        }
        else if(document.activeElement === navSecond){
          navFirst.focus();
          eventNav.preventDefault();
        }
      } else{ // Tab (Forward)
        if(document.activeElement === navLast){
          navFirst.focus();
          eventNav.preventDefault();
        }
        else if(document.activeElement === navFirst){
          navSecond.focus();
          eventNav.preventDefault();
        }
      }
    }
  }

  /* Focus trap wishlist */
  // Get all links
  function trapWishlist(eventWishlist){
    const wishlistElements = essWishlist.querySelectorAll('summary,button,a,input,select,textarea,[tabindex="0"]');
    const wishlistFirst = wishlistElements[0];
    const wishlistLast = wishlistElements[wishlistElements.length - 1];
    // Handle Escape key
    if(eventWishlist.key === 'Escape'){
      wishlistClose();
      eventWishlist.preventDefault();
      return;
    }
    // Handle Tab key (Focus Trap)
    if (eventWishlist.key === 'Tab'){
      if(eventWishlist.shiftKey){ // Shift + Tab (Backward)
        if(document.activeElement === wishlistFirst){
          wishlistLast.focus();
          eventWishlist.preventDefault();
        }
      } else{ // Tab (Forward)
        if(document.activeElement === wishlistLast){
          wishlistFirst.focus();
          eventWishlist.preventDefault();
        }
      }
    }
  }

  /* Menu buttons */
  essButtons.forEach(button => {
    button.addEventListener('click',(event) => {
      if(button.classList.contains('ess-icon-nav-wrapper')){
        if(!navButtonDisabled){
          essHeader.scrollIntoView({behavior:"smooth",block:"start"});
          essMenuActive = !essMenuActive;
          essResizing();
          let isExpanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded',!isExpanded);
          document.body.classList.toggle('menu-active');

          if(essMenuActive){
            window.addEventListener('keydown',trapNav);
            document.body.classList.add('ess-nav-overflow-hidden');
          } else{
            window.removeEventListener('keydown',trapNav);
            document.body.classList.remove('ess-nav-overflow-hidden');
          }
          navButtonDisabled = true;
          setTimeout(function(){
            navButtonDisabled = false;
          },400);
        }
      } else if(button.classList.contains('ess-icon-cart-wrapper')){
        event.preventDefault();
      } else if(button.classList.contains('ess-icon-wishlist-wrapper')){
        event.preventDefault();
        if(!wishlistButtonDisabled){
          wishlistOpen();
        }
      } else{

      }
    });
  });

  /* Wishlist open on click on buttons or by adding a product */
  function wishlistOpen(){
    essResizing();
    essWishlistOpenButton.setAttribute('aria-expanded',true);
    essWishlistCloseButton.setAttribute('aria-expanded',true);
    document.body.classList.add('wishlist-active');
    document.body.classList.add('ess-wishlist-overflow-hidden');
    window.addEventListener('keydown',trapWishlist);
    wishlistButtonDisabled = true;
    setTimeout(function(){
      wishlistButtonDisabled = false;
      essWishlistCloseButton.focus({focusVisible:false});
    },400);
  }
  /* Wishlist close on click on button or overlay */
  function wishlistClose(){
    essWishlistOpenButton.focus();
    essWishlistActive = false;
    essWishlistOpenButton.setAttribute('aria-expanded',false);
    essWishlistCloseButton.setAttribute('aria-expanded',false);
    document.body.classList.remove('wishlist-active');
    document.body.classList.remove('ess-wishlist-overflow-hidden');
    window.removeEventListener('keydown',trapWishlist);
  };
  essWishlistOverlay.addEventListener('click',function(){
    wishlistClose();
  });
  essWishlistCloseButton.addEventListener('click',function(){
    wishlistClose();
  });










/* Wishlist management */
initWishlist();

function getWishlist(){
  return JSON.parse(localStorage.getItem('essentials_wishlist')) || [];
}

function setWishlist(wishlist){
  localStorage.setItem('essentials_wishlist', JSON.stringify(wishlist));
  updateWishlistUI();
}

function initWishlist(){
  updateWishlistUI();

  document.addEventListener('click', (e) => {
    const essWishlistBtn = e.target.closest('.ess-wishlist-add-button');
    if (!essWishlistBtn) return;

    const productData = {
      desc: essWishlistBtn.dataset.productDesc || "",
      id: essWishlistBtn.dataset.productId,
      handle: essWishlistBtn.dataset.productHandle,
      title: essWishlistBtn.dataset.productTitle,
      url: essWishlistBtn.dataset.productUrl,
      img: essWishlistBtn.dataset.productImg,
      variantId: essWishlistBtn.dataset.variantId,
      price: essWishlistBtn.dataset.productPrice
    };

    let wishlist = getWishlist();
    const index = wishlist.findIndex(item => item.id === productData.id);

    if (index > -1) {
      // Remove from wishlist
      wishlistOpen();
      return;
      wishlist.splice(index, 1);
      setWishlist(wishlist);
    } else {
      // Add to wishlist
      wishlist.push(productData);
      setWishlist(wishlist);
      //openWishlistDrawer();
      wishlistOpen();
    }
  });

  // Close drawer on overlay click
  //document.getElementById('WishlistDrawer-Overlay')?.addEventListener('click', closeWishlistDrawer);
}

function updateWishlistUI() {
  const wishlist = getWishlist();
  const itemsContainer = document.getElementById('WishlistItems');
  const emptyMessage = document.getElementById('WishlistEmpty');
  
  // Update all buttons on page
  document.querySelectorAll('.ess-wishlist-add-button').forEach(btn => {
    const isInWishlist = wishlist.some(item => item.id === btn.dataset.productId);
    btn.classList.toggle('ess-product-is-on-wishlist', isInWishlist);
  });

  if (!itemsContainer) return;

  if (wishlist.length === 0) {
    emptyMessage.style.display = 'block';
    itemsContainer.innerHTML = '';
    return;
  }

  emptyMessage.style.display = 'none';
  itemsContainer.innerHTML = wishlist.map(item => `
    <div class="ess-wishlist-item" data-id="${item.id}">
      <div class="ess-wishlist-item-left">
        <a href="${item.url}">
          <img src="${item.img.replace('width=140','width=300')}" alt="${item.title}" loading="lazy">
        </a>
      </div>
      <div class="ess-wishlist-item-info">
        <div>
          <div>
            <a href="${item.url}" class="ess-wishlist-item-title">${item.title}</a>
            <div class="ess-cart-drawer-desc">
              ${item.desc}
            </div>
          </div>
        </div>
        <div class="ess-wishlist-item-actions">
            <a href="${item.url}" type="button" 
            class="button ess-wishlist-add-to-cart ess-button-regular"
            data-product-variant-id="${item.variantId}"
            data-product-item-id="${item.id}">
            ${window.themeTranslations.goToProduct}
            </a>
        </div>
      </div>
      <div class="ess-wishlist-item-right">
        <button type="button" 
          class="button button--tertiary ess-wishlist-remove-button" 
          aria-label="Remove product" 
          data-product-item-id="${item.id}"
        >
          <span class="svg-wrapper">
            <svg width="100%" height="100%" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.89938 11.3137L5.65674 7.07103L1.4141 11.3137L-0.000115197 9.89946L4.24252 5.65682L-0.000115871 1.41418L1.4141 -3.51667e-05L5.65674 4.24261L9.89938 -3.51667e-05L11.3136 1.41418L7.07095 5.65682L11.3136 9.89946L9.89938 11.3137Z" fill="#F0E1D2"></path>
            </svg>
          </span>
        </button>
        <div class="ess-wishlist-price">${item.price}</div>
      </div>
    </div>
  `).join('');
}

/*
function openWishlistDrawer() {
  document.getElementById('WishlistDrawer').classList.add('active');
  document.body.classList.add('overflow-hidden');
}*/

function closeWishlistDrawer() {
  document.getElementById('WishlistDrawer').classList.remove('active');
  document.body.classList.remove('overflow-hidden');
}
document.addEventListener('click',(ewr) => {
  const essWishlistRemoveItemBtn = ewr.target.closest('.ess-wishlist-remove-button');
  if (!essWishlistRemoveItemBtn) return;
  removeFromWishlist(essWishlistRemoveItemBtn.dataset.productItemId);
});
function removeFromWishlist(id) {
  let wishlist = getWishlist();
  wishlist = wishlist.filter(item => item.id !== id);
  setWishlist(wishlist);
}

// Add to Cart Logic: Closes Wishlist, adds to cart via AJAX, opens Cart Drawer
/*
document.addEventListener('click',(ew) => {
  const essWishlistAddToCartBtn = ew.target.closest('.ess-wishlist-add-to-cart');
  if (!essWishlistAddToCartBtn) return;
  wishlistAddToCart(essWishlistAddToCartBtn.dataset.productVariantId,essWishlistAddToCartBtn.dataset.productItemId);
});
function wishlistAddToCart(variantId,productId){
  //closeWishlistDrawer();
  wishlistClose();

  let formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    // Optional: Remove from wishlist after successful add to cart
    removeFromWishlist(productId);

    // Trigger Dawn's native cart drawer update and open event
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Dawn theme cart drawer components usually listen to section rendering updates
      fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
        .then(res => res.json())
        .then(sections => {
          const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const innerHTML = html.querySelector('#CartDrawer').innerHTML;
          document.querySelector('#CartDrawer').innerHTML = innerHTML;
          
          // Open Dawn's Cart Drawer natively
          cartDrawer.classList.add('active');
          cartDrawer.classList.remove('is-empty');
          document.body.classList.add('overflow-hidden');
        });
    } else {
      // Fallback if Cart Drawer isn't utilized as a custom element component
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  })
  .catch((error) => {
    console.error('Error adding to cart:', error);
  });
}*/














  /* Product feature zoom */
  const essZoomButtons = document.querySelectorAll('.ess-product-feature-zoom-button');
  /*essZoomButtons.forEach(button => {
    button.addEventListener('click',(event) => {
      button.disabled = true;
      button.closest('.ess-featured-img-icon-wrap').classList.toggle('scaled');
      setTimeout(function(){
        button.disabled = false;
      },400);
    });
  });*/

  /*
  // Schließen mit der Escape-Taste (wichtig für Tastatur-Nutzer)
  document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && dropdownBtn.getAttribute('aria-expanded') === 'true') {
    dropdownBtn.setAttribute('aria-expanded', 'false');
    dropdownMenu.hidden = true;
    dropdownBtn.focus(); // Fokus zurück auf den Button setzen
  }
  });
  */

});